import { replace, trim } from 'lodash'

const REPLACE_REGEX = new RegExp(/,/g)

export const cleanPatentNumber = (patentNumber: string) => {
  let result = trim(patentNumber)
  result = replace(result, REPLACE_REGEX, '')
  return result.toUpperCase()
}
